import { render, staticRenderFns } from "./UpmsUser.vue?vue&type=template&id=58ee5f34&"
import script from "./UpmsUser.vue?vue&type=script&lang=js&"
export * from "./UpmsUser.vue?vue&type=script&lang=js&"
import style0 from "./UpmsUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports